/**
 * Global theme scripts.
 * Loaded after pubsub.js in the layout.
 *
 * Keeps the theme no-JS while providing the same file structure as Shopify Dawn.
 */

window.Theme = window.Theme || {};

// Stub for future section registration and pub/sub events.
// Shopify.PubSub is provided by pubsub.js.
